import app from "../_app";

document.addEventListener("DOMContentLoaded", function (event) {

    let clearBtn = document.querySelector("#clear-discount-btn");
    let applyBtn = document.querySelector("#apply-discount-btn");
    let discountCodeError = document.querySelector("#discount-code-error");
    let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
    let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
    let discountCodeInput = document.querySelector("#discount-code-input");
    let totalCartSelector = document.querySelector(".cart__summary-totalprice"); // Total Cart Selector to update the total amount.
    let authorization_token;

    let checkoutContainer = document.createElement('div');
    document.body.appendChild(checkoutContainer);
    if (localStorage.discountCode) applyDiscount(JSON.parse(localStorage.discountCode).code);
    if (applyBtn)
        applyBtn.addEventListener("click", function (e) {
            e.preventDefault()
            applyDiscount(discountCodeInput.value);
        });
    if (clearBtn)
        clearBtn.addEventListener("click", function (e) {
            e.preventDefault()
            clearDiscount();
        });

    function clearDiscount() {
        discountCodeValue.innerHTML = "";
        discountCodeError.innerHTML = "";
        clearLocalStorage();
        fetch("/discount/CLEAR");
    }

    function clearLocalStorage() {
        if (discountCodeWrapper) discountCodeWrapper.style.display = "none";
        if (totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
        localStorage.removeItem("discountCode");
    }

    function applyDiscount(code) {
        if (applyBtn) {
            applyBtn.innerHTML = app.translationHelper('cart.discount.applying') + "<div class='loader'></div>";
            applyBtn.style.pointerEvents = "none";
        }
        fetch("/payments/config", {"method": "GET"})
            .then(function (response) {
                return response.json()
            })
            .then(function (data) {
                const checkout_json_url = '/wallets/checkouts/';
                authorization_token = btoa(data.paymentInstruments.accessToken)
                fetch('/cart.js', {}).then(function (res) {
                    return res.json();
                })
                    .then(function (data) {
                        let body = {
                            "checkout": {
                                "country": Shopify.country,
                                "discount_code": code,
                                "line_items": data.items,
                                'presentment_currency': Shopify.currency.active
                            }
                        }
                        fetch(checkout_json_url, {
                            "headers": {
                                "accept": "*/*", "cache-control": "no-cache",
                                "authorization": "Basic " + authorization_token,
                                "content-type": "application/json, text/javascript",
                                "pragma": "no-cache", "sec-fetch-dest": "empty",
                                "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
                            },
                            "referrerPolicy": "strict-origin-when-cross-origin",
                            "method": "POST", "mode": "cors", "credentials": "include",
                            "body": JSON.stringify(body)
                        })
                            .then(function (response) {
                                return response.json()
                            })
                            .then(function (data) {
                                if (data.checkout && data.checkout.applied_discounts.length > 0) {
                                    let discountApplyUrl = "/discount/" + code + "?v=" + Date.now() + "&redirect=/checkout/";
                                    fetch(discountApplyUrl, {}).then(function (response) {
                                        return response.text();
                                    })
                                    if (discountCodeWrapper) discountCodeWrapper.style.display = "inline-block";
                                    if (discountCodeError) discountCodeError.innerHTML = "";
                                    if (discountCodeValue) discountCodeValue.innerHTML = "<strong>" + data.checkout.applied_discounts[0].title + "</strong> - (" + data.checkout.applied_discounts[0].amount + ' ' + Shopify.currency.active + ")";
                                    let localStorageValue = {
                                        'code': code.trim(),
                                        'totalCart': data.checkout.total_line_items_price
                                    };
                                    localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
                                    if (totalCartSelector) totalCartSelector.innerHTML = "<s>" + data.checkout.total_line_items_price + "</s>" + data.checkout.total_price;
                                } else {
                                    if (discountCodeValue) discountCodeValue.innerHTML = "";
                                    if (discountCodeError) discountCodeError.innerHTML = app.translationHelper('cart.discount.enter_valid_code');
                                    clearLocalStorage();
                                }
                            }).finally(function (params) {
                            if (applyBtn) {
                                applyBtn.innerHTML = app.translationHelper('cart.discount.apply');
                                applyBtn.style.pointerEvents = "all";
                            }
                        });
                    });
            });
    }
});
